import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=487ea3dc"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports